import type { IAsset } from '../../Assets/IAsset';

export class AudioCompElement {
    id: number | string;

    isAssetLoading = false;

    hidden = false;

    volume = 0.5;

    opacity = 1.0;

    assetId: string;

    gainValue: number;

    /**
     * IMPORTANT: This is NOT reliable property for the compositor's logic.
     * Do not use it for any calculations in the compositor!
     */
    originalElement: any;

    isContainsAsset(asset: IAsset): boolean {
        return this.originalElement.isContainsAsset(asset);
    }

    toObject() {}
}
